import { MutationKey } from './MutationKey';

const DETAILS = 'details';
const GRID = 'grid';
const CHART = 'chart';
export class QueryKey {
  constructor(...key) {
    this.entityKey = key;
  }

  all(...key) {
    return [...this.entityKey, ...key];
  }

  details() {
    return this.next(DETAILS);
  }

  //When we need to pass more than 1 key, as we do in AT/CT for chart, annotations etc
  exact(...key) {
    return (prop = '') => {
      return [...this.all(), ...key, prop];
    };
  }

  grid() {
    return (params = '') => [...this.grids()(), params];
  }

  grids() {
    return () => this.all(GRID);
  }

  chart() {
    return this.exact(CHART);
  }

  charts() {
    return () => this.all(CHART);
  }

  mutations() {
    return new MutationKey(...this.entityKey);
  }

  next(...key) {
    return (id) => {
      return [...this.all(), id, ...key];
    };
  }

  query(key = '') {
    return new QueryKey(...this.entityKey, key);
  }

  getPath() {
    return this.entityKey;
  }
}
